import { getConversation_conversations_data_messages } from '../../../__generated__/getConversation';
import { ProductTypeEnum } from '../../../__generated__/globalTypes';
import CanvasLayoutStyle from '../../style_detail/canvas_layout_style';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import SuggestionsButtons from './SuggestionsButtons';
import { STYLE_CARD_SUBTRACT_HEIGHT } from '../../../constants';
import { useVisualViewport } from '../../../utils/useVisaulViewport';
import useDynamicItemDetail from '../hooks/useDynamicItemDetail';
import useMessageContainerRef from '../hooks/useMessageContainerRef';
import langUtils from '../../language/utils';
import { useStyles } from '../styles';
import { Collapse } from 'react-collapse';

const SuggestionsSingleSlide = ({
    message,
    messageIndex,
    openedInfoMessage,
    setOpenedInfoMessage,
}: {
    message: getConversation_conversations_data_messages;
    messageIndex: number;
    openedInfoMessage: string | null;
    setOpenedInfoMessage: (value: string | null) => void;
}) => {
    const classes = useStyles();
    const windowSize = useVisualViewport();
    const { setShowDynamicItemDetail } = useDynamicItemDetail();
    const messageContainerRef = useMessageContainerRef();
    const descriptionRef = useRef<HTMLDivElement>(null);
    const elements = message.elements;
    const element = elements && Array.isArray(elements) && elements.length ? elements[0] : null;
    const isOpenInfo = message.taffiId && openedInfoMessage?.includes(message.taffiId);

    const renderStyleCard = useCallback(() => {
        if (!windowSize.viewport.height) {
            return null;
        }
        const productType = element?.productType;
        if (productType === ProductTypeEnum.item) {
            return (
                <img
                    src={element?.value!!}
                    alt="style"
                    className={classes.styleImage}
                    style={{
                        marginBottom: '8px',
                        border: '1px solid #f2f2f2',
                        width: '100%',
                        height:
                            windowSize.viewport.width >= 1024
                                ? 630
                                : windowSize.viewport.height - STYLE_CARD_SUBTRACT_HEIGHT,
                    }}
                    onClick={() => {
                        let item: any = element?.items?.find((data) => data?.taffiId === element?.productTaffiId);
                        if (item?.images?.length) {
                            item = { ...item, images: [element?.value, ...item.images], storeUrl: element?.url };
                        }
                        if (element?.items?.length) {
                            setShowDynamicItemDetail(item);
                        }
                    }}
                />
            );
        }
        const items = element?.items?.map((i: any) => {
            return {
                ...i,
                metadata: {
                    category: i?.data?.metadata?.category || i?.category,
                },
            };
        });
        return (
            <CanvasLayoutStyle
                items={items ?? []}
                heightContent={
                    windowSize.viewport.width >= 1024 ? 630 : windowSize.viewport.height - STYLE_CARD_SUBTRACT_HEIGHT
                }
                style={element}
                setShowDynamicItemDetail={setShowDynamicItemDetail}
            />
        );
    }, [classes.styleImage, element, setShowDynamicItemDetail, windowSize.viewport.height, windowSize.viewport.width]);

    const getDescription = useMemo(() => {
        if (!message.content || !message.taffiId) {
            return '';
        }
        return message.content.replace(/[^:]+(: )/, '');
    }, [message]);

    const renderDescription = () => ({ __html: getDescription });

    useEffect(() => {
        if (isOpenInfo && descriptionRef.current && messageContainerRef.current) {
            try {
                // check if descriptionRef.current is totally visible, if not, scroll to it
                const { bottom } = descriptionRef.current.getBoundingClientRect();
                if (bottom > messageContainerRef.current.clientHeight + 60) {
                    messageContainerRef.current.scrollTo({
                        top:
                            messageContainerRef.current.scrollTop +
                            (bottom - messageContainerRef.current.clientHeight - 60), // 60 is the height of the top bar
                        behavior: 'smooth',
                    });
                }
            } catch (e) {
                console.error(e);
            }
        }
    }, [descriptionRef, element, isOpenInfo, messageContainerRef]);

    return (
        <div style={{ height: '100%' }}>
            {renderStyleCard()}
            <SuggestionsButtons
                message={message}
                messageIndex={messageIndex}
                openedInfoMessage={openedInfoMessage}
                setOpenedInfoMessage={setOpenedInfoMessage}
            />
            <Collapse isOpened={isOpenInfo}>
                <div
                    ref={descriptionRef}
                    className={'suggestions-details'}
                    style={{
                        ...langUtils.getLanguageStyle(message?.language),
                    }}
                >
                    <span className={`suggestions-description`} dangerouslySetInnerHTML={renderDescription()}></span>
                </div>
            </Collapse>
        </div>
    );
};

export default SuggestionsSingleSlide;
